module.exports = __webpack_public_path__ + "static/media/The Girl in a Swing_2.8829af5c.jpg";